"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pgpDecrypt = exports.verifySignature = exports.sign = exports.pgpEncrypt = exports.generateKeyPair = exports.PGPHelper = void 0;
const tslib_1 = require("tslib");
const openpgp = require("openpgp");
const PGPHelper = {
  generateKeyPair() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const keys = yield openpgp.generateKey({
        type: 'rsa',
        rsaBits: 2048,
        userIDs: [{
          name: '',
          email: ''
        }]
      });
      return {
        privateKeyArmored: keys.privateKey,
        publicKeyArmored: keys.publicKey
      };
    });
  },
  sign(_ref) {
    let {
      message,
      signingKey
    } = _ref;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const messageObject = yield openpgp.createMessage({
        text: message
      });
      const privateKey = yield openpgp.readPrivateKey({
        armoredKey: signingKey
      });
      return yield openpgp.sign({
        message: messageObject,
        signingKeys: privateKey,
        detached: true
      });
    });
  },
  pgpEncrypt(_ref2) {
    let {
      plainText,
      keys
    } = _ref2;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const pgpKeys = [];
      for (let i = 0; i < keys.length; i++) {
        pgpKeys.push(yield openpgp.readKey({
          armoredKey: keys[i]
        }));
      }
      const message = yield openpgp.createMessage({
        text: plainText
      });
      const encrypted = yield openpgp.encrypt({
        message: message,
        encryptionKeys: pgpKeys
      });
      return encrypted;
    });
  },
  pgpDecrypt(_ref3) {
    let {
      cipherText,
      toPrivateKeyArmored
    } = _ref3;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const message = yield openpgp.readMessage({
        armoredMessage: cipherText
      });
      const privateKey = yield openpgp.readPrivateKey({
        armoredKey: toPrivateKeyArmored
      });
      const {
        data: decrypted
      } = yield openpgp.decrypt({
        message,
        decryptionKeys: privateKey
      });
      return decrypted;
    });
  },
  verifySignature(_ref4) {
    let {
      messageContent,
      signatureArmored,
      publicKeyArmored
    } = _ref4;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
      const message = yield openpgp.createMessage({
        text: messageContent
      });
      const signature = yield openpgp.readSignature({
        armoredSignature: signatureArmored
      });
      const publicKey = yield openpgp.readKey({
        armoredKey: publicKeyArmored
      });
      const verificationResult = yield openpgp.verify({
        // setting date to 1 day in the future to avoid issues with clock skew
        date: new Date(Date.now() + 1000 * 60 * 60 * 24),
        message,
        signature,
        verificationKeys: publicKey
      });
      const {
        verified
      } = verificationResult.signatures[0];
      try {
        yield verified;
      } catch (e) {
        throw new Error('Signature could not be verified: ' + e);
      }
    });
  }
};
exports.PGPHelper = PGPHelper;
const generateKeyPair = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const keys = yield openpgp.generateKey({
    type: 'rsa',
    rsaBits: 2048,
    userIDs: [{
      name: '',
      email: ''
    }]
  });
  return {
    privateKeyArmored: keys.privateKey,
    publicKeyArmored: keys.publicKey
  };
});
exports.generateKeyPair = generateKeyPair;
const pgpEncrypt = _ref5 => {
  let {
    plainText,
    keys
  } = _ref5;
  return tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const pgpKeys = [];
    for (let i = 0; i < keys.length; i++) {
      pgpKeys.push(yield openpgp.readKey({
        armoredKey: keys[i]
      }));
    }
    const message = yield openpgp.createMessage({
      text: plainText
    });
    const encrypted = yield openpgp.encrypt({
      message: message,
      encryptionKeys: pgpKeys
    });
    return encrypted;
  });
};
exports.pgpEncrypt = pgpEncrypt;
const sign = _ref6 => {
  let {
    message,
    signingKey
  } = _ref6;
  return tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const messageObject = yield openpgp.createMessage({
      text: message
    });
    const privateKey = yield openpgp.readPrivateKey({
      armoredKey: signingKey
    });
    return yield openpgp.sign({
      message: messageObject,
      signingKeys: privateKey,
      detached: true
    });
  });
};
exports.sign = sign;
const verifySignature = _ref7 => {
  let {
    messageContent,
    signatureArmored,
    publicKeyArmored
  } = _ref7;
  return tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const message = yield openpgp.createMessage({
      text: messageContent
    });
    const signature = yield openpgp.readSignature({
      armoredSignature: signatureArmored
    });
    const publicKey = yield openpgp.readKey({
      armoredKey: publicKeyArmored
    });
    const verificationResult = yield openpgp.verify({
      message,
      signature,
      verificationKeys: publicKey
    });
    const {
      verified
    } = verificationResult.signatures[0];
    try {
      yield verified;
    } catch (e) {
      throw new Error('Signature could not be verified: ' + e);
    }
  });
};
exports.verifySignature = verifySignature;
const pgpDecrypt = _ref8 => {
  let {
    cipherText,
    toPrivateKeyArmored
  } = _ref8;
  return tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const message = yield openpgp.readMessage({
      armoredMessage: cipherText
    });
    const privateKey = yield openpgp.readPrivateKey({
      armoredKey: toPrivateKeyArmored
    });
    const {
      data: decrypted
    } = yield openpgp.decrypt({
      message,
      decryptionKeys: privateKey
    });
    return decrypted;
  });
};
exports.pgpDecrypt = pgpDecrypt;
//# sourceMappingURL=pgp.js.map